// @ts-strict-ignore

import { Injectable } from '@angular/core';
import { BehaviorSubject, mergeMap, Observable, of } from 'rxjs';
import {
  AppConstants,
  LMContextUtilService,
  LMDialogButtonKey,
  LMGlobalUtilService,
  LMUniqueIdService
} from '@app/utils';
import { LMDrillAroundComponent } from '@components/drillaround/lm-drill-around.component';
import {
  DrillPointsParams,
  LMContextService,
  LMDrillService,
  LMModalOpenService,
  LMModalWrapperService,
  LMSpecService,
  LMUrlUtilService
} from '@app/services';
import { catchError, filter } from "rxjs/operators";
import { RouterStateSnapshot } from "@angular/router";
import { DrillResource } from "@app/resources";
import { LMDrillAroundNode } from '@components/drillaround/lm-drill-around-wc';


/*
IN MINGLE
- DONE: Navigation guard, if yes sens message to out app (like launch shortcut)
- DONE: should i send mingle messages from the drill-around window
- DONE: not in mingle we are going top in a new tab

- DONE: handle no drill point found and errors.
- DONE: automatically show refresh on the object views user can refresh (should refreshbe part of a list drill called out actions)
- DONE: what de we show if the user selected a record, not  drill point.  We show the drill points with links to the tree node.
- DONE: Not worth it now investigated child routes and route reuse (trying to not have to load data - backend call, when user clicks around, need to balance that with memory usage)
- DONE: How do we handle a drill point to a summary form, -- that must be a PDF which is being handled
- DONE: MAke sure the DrillAroundNode propagates to the subcomponets like a list
- DONE: Key Field Drill (in drill mode opens another drill window)
- DONE: give some visual affordance for a record drill
- DONE: Bread crumbs are the current tree path and inclduing the root (not interactive)
- DONE - use the URL param drill-around to track usage.
    - DrillAround usage: drill-around=true -> launches drill -->  http://usspndboehm02.infor.com:8080/uitestsql/ManufacturerMaintWeb10x/drill/Product%281%2C1%2C10%29._drillpoints
    - DrillPointUsage: drill-around=<drillPoint> , http://usspndboehm02.infor.com:8080/uitestsql/ManufacturerMaintWeb10x/drill/Product(1%2C1%2C10).Product_Translation?csk.cli=true&csk.drillaround=true&drill-around=Product_Translation&output=spec
- DONE - drop the drill counts
- DONE: keyField drill correct representative text
- DONE: bread crumbs interactive
- DONE: redirect to record nodes already created
- DONE: initial view show rootDrillpoints (philip)
- DONE: Retain the full context of drill around, this includes header records and panel titles.
- DONE: drill within drillAround modal should not create node if no drills exist.
- DONE: key fields need to say me wind andbeadd by KeyFIeld lable and RepText
- DONE: save page state
- DONE: DrillAround navigation guard
- DONE: Add the root node to the tree and make it clickable in breadcrumb list
- DONE:  form toolbar
  -- restrict to just run pdf
  -- should we include drill on the form
- DONE: DrillAround route component

Issues:
- When using breadcrumbs with overflow `this.breadCrumb.updated({ style: 'alternate', truncate: false, breadcrumbs: breadCrumbs })` has
  flashing issue when the crumb get long and resizing the widget or browser.

Questions:
 - means key field need to work
 - list records works
 - document drill example
 - step control needs to propagate the drill.
 - put in data-automation id
*/

@Injectable()
export class LMDrillAroundService {

  private openDialogs = 0;
  private static DRILL_AROUND_CONTEXT_MESSAGE_ID ='landmarkDrillAroundContext';

  constructor(
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmContextService: LMContextService,
    private lmUniqueIdService: LMUniqueIdService,
    private lmDrillService: LMDrillService,
    private lmSpecService: LMSpecService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmContextUtilService: LMContextUtilService,
    private lmModalWrapperService: LMModalWrapperService,
    private lmModalOpenService: LMModalOpenService
  ) {
    // no-op
  }
  public drillAroundIsOpen(): boolean {
    return this.openDialogs > 0 || this.lmContextService.drillAroundWindow();
  }

  public runDrillAroundGuard(nextState?: RouterStateSnapshot): Promise<any> {
    const youMayNavigateSource = new BehaviorSubject<boolean>(false);
    const youMayNavigate: Observable<boolean> = youMayNavigateSource.asObservable();
    const dialogId = 'drill-around-guard';
    const title = Soho.Locale.translate('DrillNavigateAwayMessage');
    const mingleTitle = Soho.Locale.translate('MingleDrillNavigateAwayMessage');
    const buttons = [
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.YES ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.YES),
        click: (e, modal) => {
          this.openDialogs = 0;

          if (!this.lmContextService.inMingle()) {
            this.lmGlobalUtilService.navigate(nextState.url);
          } else {
            this.lmContextUtilService.sendDrillbackMessage(nextState.url);
          }
          youMayNavigateSource.next(false);
          modal.close();
        }
      },
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.NO ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.NO),
        click: (e, modal) => {
          this.openDialogs = 0;

          if (!this.lmContextService.inMingle()) {
            this.lmGlobalUtilService.navigate(nextState.url, null, 'external');
          }
          // in mingle do nothing.
          youMayNavigateSource.next(false);
          modal.close();
        }
      }
    ];

    // Show the confirmation message dialog.
    const message = this.lmModalWrapperService
      .message()
      .message(this.lmContextService.inMingle() ? mingleTitle : title) //Soho.Locale.translate('DrillNavigateAwayMessage'))
      .title(AppConstants.DRILL_AROUND_LABEL)
      .buttons(buttons)
      .open();

    return youMayNavigate.pipe(filter(el => el)).toPromise();
  }
  
  public runDrillAround(drillResponse: LMDrillResponse) {
    if (drillResponse?.drillPoints?.length > 0) {
      const drillResource = new DrillResource({ resourceId: drillResponse.dataView.resourceId, drillName: '_drillaround_' });
      const drillUrl = this.lmUrlUtilService.buildUrl({ resource: drillResource, webApp: 'web' });
      if (this.lmContextService.inMingle()) {
        // open in a portal tab
        this.lmContextUtilService.openPortalTab(drillUrl, { hideTitle: false, hideMenu: true });
        // send context message to drill around widget
        // const messageText = drillResponse.dataView.representativeText ? drillResponse.dataView.representativeText : drillResponse.dataView.busClassName;
        // const drillAroundMsg = {
        //   screenId: drillResource.resourceId,
        //   logicalId: this.lmContextService.getLogicalId(),
        //   originatingTime: new Date().getTime(),
        //   entities: [
        //     {
        //       entityType: LMDrillAroundService.DRILL_AROUND_CONTEXT_MESSAGE_ID,
        //       drillURL: drillUrl
        //     },
        //   ],
        //   messageText: messageText,
        // };
        //
        // this.lmContextUtilService.publishStandardContext(LMDrillAroundService.DRILL_AROUND_CONTEXT_MESSAGE_ID, drillAroundMsg);
      } else {
        this.lmGlobalUtilService.navigate(drillUrl, null, 'external');
      }
    } else {
      this.lmModalWrapperService
        .message()
        .message(Soho.Locale.translate('NoDrillsAvailable'))
        .title(AppConstants.DRILL_AROUND_LABEL)
        .showCloseBtn(true)
        .open();
    }
  }

  public openDrillAroundDialog(dataView: LMDataView, drillActions: Array<LMDrillAction>) {

    let drillAroundComponent: LMDrillAroundComponent;
    const attributes: SohoAttributesArray = [
      {
        name:  'data-automation-id',
        value: `lm-drill-around-modal`
      }
    ];

    const sohoModalOptions: SohoModalOptions = {
      fullsize: 'always',
      attributes,
      showCloseBtn: true,
      cssClass: 'lm-drill-around-modal'
    };

    let title;
    if (dataView.representativeText) {
      title = dataView.representativeText + ' - ' + AppConstants.DRILL_AROUND_LABEL;
    } else {
      title = dataView.busClassName + ' - ' + AppConstants.DRILL_AROUND_LABEL;
    }

    const modalRef = this.lmModalWrapperService.modal(LMDrillAroundComponent, sohoModalOptions)
      .title(title)
      .isAlert(false)
      .open()
      .apply((dialogComponent: LMDrillAroundComponent) => {
        drillAroundComponent = dialogComponent;
        dialogComponent.rootDataView = dataView;
        dialogComponent.rootDrillActions = drillActions;
      })
      .afterOpen(() => {
        this.openDialogs++;
      })
      .beforeClose(() => {
        if (this.lmContextService.isUnified()) {
          this.lmModalOpenService.removeModal(modalRef.uuid);
        }
        this.openDialogs--;
        if (!modalRef.dialogResult) {
          return true;
        }
      });
  }

  public buildBreadCrumbs(root: string | undefined, callBack: SohoBreadcrumbItemCallbackFunction, node?: LMDrillAroundNode): Array<SohoBreadcrumbItemOptions> {
    const crumbs: Array<SohoBreadcrumbItemOptions> = [];

    if (node) {
      let next: LMDrillAroundNode = node;

      while (next) {
        crumbs.push(this.buildCrumb(next, callBack));
        next = next.lmParent;
      }
    }

    crumbs.reverse();

    return crumbs;
  }

  private buildCrumb(node: LMDrillAroundNode, callBack: SohoBreadcrumbItemCallbackFunction):SohoBreadcrumbItemOptions {
    let title;
    if (node.text) {
      title = node.text;
    } else {
      title = node.dataView.representativeText ? node.dataView.representativeText : node.dataView.busClassName;
    }
    const crumb: SohoBreadcrumbItemOptions = {
      id: node.id,
      content: title,
      callback: callBack
    };
    return crumb;
  }

  public buildDrillAroundViewInfo(drillAroundNode: LMDrillAroundNode): Observable<LMDrillAroundViewInfo> {
    if (!drillAroundNode.drillAction) {    // this is a record or panel type, not a drillpoint
      return of({
        key: drillAroundNode.id,
        dataView: drillAroundNode.dataView,
        drillAction: drillAroundNode.drillAction,
        type: drillAroundNode.lmType as any, // lmType is either 'record' or 'panel'. Annoying but get an error on this w/o the 'any' type
        spec: undefined,
        urlInfo: undefined
      } as LMDrillAroundViewInfo);
      // do we want to go to the backend and get the repImage, createStamp, updateStamp?
    } else {
      const drillUrl = this.lmUrlUtilService.addParamToUrl(drillAroundNode.drillAction.drillUrl, 'drill-around', drillAroundNode.drillAction.drillId);
      return this.lmSpecService.getDrillSpec(drillUrl).pipe(
        mergeMap((drillSpec: LMDrillSpec) => this.buildDrillViewInfo(drillAroundNode, drillSpec)),
        catchError(error => this.buildErrorDrillViewInfo(drillAroundNode)));
    }
  }

  public fetchDrillAroundPoints(request: LMDrillAroundRequest): Observable<LMDrillResponse> {
    const drillPointsParams: DrillPointsParams = {
      dataView: request.dataView,
      fieldId: request.fieldId,
      formRequestUrl: request.formRequestUrl,
      drillAround: true
    };

    return new Observable<LMDrillResponse>(observer => {
      if (request.fieldId) {
        this.lmDrillService.getFieldDrillPoints(drillPointsParams).subscribe(response => {
          observer.next(response);
          observer.complete();
        });

      } else {
        return this.lmDrillService.getDrillPoints(drillPointsParams).subscribe(response => {
          const dataViewResponse: LMDrillResponse = {
            dataView: response.dataView,
            drillPoints: response.drillPoints
          };
          observer.next(dataViewResponse);
          observer.complete();
        });
      }
    });
  }

  private buildErrorDrillViewInfo(drillAroundNode: LMDrillAroundNode): Observable<LMDrillAroundViewInfo> {
    return of ({
      key: drillAroundNode.id,
      type: 'unknown',
      dataView: drillAroundNode.dataView,
      drillAction: drillAroundNode.drillAction,
      spec: undefined,
      urlInfo: undefined
    });
  }

  private buildDrillViewInfo(drillAroundNode: LMDrillAroundNode, drillSpec: LMDrillSpec): Observable<LMDrillAroundViewInfo> {
    if (drillSpec.redirectUrl) {

      if (drillSpec.redirectUrl.indexOf('output=pdf') > -1) {
        // this.lmGlobalUtilService.navigate(response.redirectUrl, null, 'external');
        return of( this.buildPdfDrillInfo(drillAroundNode));
      } else if (drillSpec.redirectUrl.indexOf('/document/') > -1) {
        // this.lmGlobalUtilService.navigate(response.redirectUrl);
        return of({
          key: drillAroundNode.id,
          type: 'document',
          dataView: drillAroundNode.dataView,
          drillAction: drillAroundNode.drillAction,
          urlInfo: undefined,
          spec: undefined
        });
      } else {
        const resourceType = this.lmUrlUtilService.getResourceTypeFromUrl(drillSpec.redirectUrl);
        if (resourceType === 'form') {
          return this.buildFormDrillInfo(drillAroundNode, drillSpec.redirectUrl);
        } else if (resourceType === 'list') {
          return this.buildListDrillInfo(drillAroundNode, drillSpec.redirectUrl);
        } else if (resourceType === 'page') {
          return this.buildPageDrillInfo(drillAroundNode, drillSpec.redirectUrl);
        } else {
          return of({
            key: drillAroundNode.id,
            type: 'unknown',
            dataView: drillAroundNode.dataView,
            drillAction: drillAroundNode.drillAction,
            urlInfo: undefined,
            spec: undefined
          });  //  WHAT CASE WOULD this ever be???
        }
      }
    }
  }

  private buildFormDrillInfo(drillAroundNode: LMDrillAroundNode, url: string): Observable<LMDrillAroundViewInfo> {
    return new Observable<LMDrillAroundViewInfo>(observer => {
      this.lmSpecService.getFormSpec(url).subscribe((response: LMFormSpecResponse) => {
        if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
          observer.error(response);
        } else {
          observer.next({
            key: drillAroundNode.id,
            type: 'form',
            dataView: drillAroundNode.dataView,
            drillAction: drillAroundNode.drillAction,
            urlInfo: response.formUrlInfo,
            spec: response.formSpec
          });
        }
        observer.complete();
      });
    });
  }

  private buildPdfDrillInfo(drillAroundNode: LMDrillAroundNode): LMDrillAroundViewInfo {
    return {
      key: drillAroundNode.id,
      type: 'pdf',
      dataView: drillAroundNode.dataView,
      drillAction: drillAroundNode.drillAction,
      urlInfo: undefined,
      spec: undefined
    };
  }

  private buildListDrillInfo(drillAroundNode: LMDrillAroundNode, url: string): Observable<LMDrillAroundViewInfo> {
    return new Observable<LMDrillAroundViewInfo>(observer => {
      this.lmSpecService.getListSpec(url).subscribe((response: LMListSpecResponse) => {
        if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
          observer.error(response);
        } else {
          observer.next({
            key: drillAroundNode.id,
            type: 'list',
            dataView: drillAroundNode.dataView,
            drillAction: drillAroundNode.drillAction,
            urlInfo: response.listUrlInfo,
            spec: response.listSpec
          });
        }
        observer.complete();

      });
    });
  }

  private buildPageDrillInfo(drillAroundNode: LMDrillAroundNode, url: string): Observable<LMDrillAroundViewInfo> {
    return new Observable<LMDrillAroundViewInfo>(observer => {
      this.lmSpecService.getPageSpec(url).subscribe((response: LMPageSpecResponse) => {
        if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
          observer.error(response);
        } else {
          observer.next({
            key: drillAroundNode.id,
            type: 'list',
            dataView: drillAroundNode.dataView,
            drillAction: drillAroundNode.drillAction,
            urlInfo: response.pageUrlInfo,
            spec: response.pageSpec
          });
        }
        observer.complete();
      });
    });
  }
}
